import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
// import { AxiosResponse } from "axios";

export default {
    async list(): Promise<types.ResCategoryList> {
        const res = {} as types.ResCategoryList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/category/list", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
